module.exports = __webpack_public_path__ + "static/Lessons on Burden of Proof-51b5f13e5726f515983005616c37263c.jpg";